import { Grid2 as Grid, TextField, MenuItem } from '@mui/material';
import PageFilters from '../ui/PageFilters';

export default function FinanceFilters({ value, onChange, professionals = [], places = [] }) {
  const handle = (key) => (e) => onChange({ ...value, [key]: e.target.value });

  const cleared = { startDate: '', endDate: '', professionalId: '', placeId: '' };

  return (
    <PageFilters
      onClear={() => onChange(cleared)}
      clearDisabled={!value.startDate && !value.endDate && !value.professionalId && !value.placeId}
    >
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <TextField fullWidth type="date" label="Início" InputLabelProps={{ shrink: true }}
          value={value.startDate || ''} onChange={handle('startDate')} />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <TextField fullWidth type="date" label="Fim" InputLabelProps={{ shrink: true }}
          value={value.endDate || ''} onChange={handle('endDate')} />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <TextField select fullWidth label="Profissional"
          value={value.professionalId || ''} onChange={handle('professionalId')}>
          <MenuItem value="">Todos</MenuItem>
          {professionals.map((p) => <MenuItem key={p.id} value={p.id}>{p.name}</MenuItem>)}
        </TextField>
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <TextField select fullWidth label="Local"
          value={value.placeId || ''} onChange={handle('placeId')}>
          <MenuItem value="">Todos</MenuItem>
          {places.map((p) => <MenuItem key={p.id} value={p.id}>{p.name}</MenuItem>)}
        </TextField>
      </Grid>
    </PageFilters>
  );
}
